import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=6ae9cc4c&"
import script from "./doc.vue?vue&type=script&lang=js&"
export * from "./doc.vue?vue&type=script&lang=js&"
import style0 from "./doc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports